import logo1998 from "../../assets/img/historicEvents/LogoIYH/1998_25.png";
import logo2000 from "../../assets/img/historicEvents/LogoJudmentDay/2000.png";
import logo2001 from "../../assets/img/historicEvents/LogoJudmentDay/2001.png";
import logo2002 from "../../assets/img/historicEvents/LogoJudmentDay/2002.png";
import logo2003 from "../../assets/img/historicEvents/LogoJudmentDay/2003.png";
import logo2004 from "../../assets/img/historicEvents/LogoJudmentDay/2004.png";
import logo2005_2008 from "../../assets/img/historicEvents/LogoJudmentDay/2005-2008.png";
import logo2009 from "../../assets/img/historicEvents/LogoJudmentDay/2009.png";

export const judgmentDayDetail = {
  "judgment-day": {
    id: "judgment-day",
    title: "Judgment Day",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "judgment-day",
        items: [
          {
            id: "judgment-day-1998",
            title: "Judgment Day",
            description: "In Your House 1998",
            imgUrl: logo1998,
          },
          {
            id: "judgment-day-2000",
            title: "Judgment Day",
            description: "2000",
            imgUrl: logo2000,
          },
          {
            id: "judgment-day-2001",
            title: "Judgment Day",
            description: "2001",
            imgUrl: logo2001,
          },
          {
            id: "judgment-day-2002",
            title: "Judgment Day",
            description: "Judge, Jury and Executioner 2002",
            imgUrl: logo2002,
          },
          {
            id: "judgment-day-2003",
            title: "Judgment Day",
            description: "2003",
            imgUrl: logo2003,
          },
          {
            id: "judgment-day-2004",
            title: "Judgment Day",
            description: "Souls will cry. 2004",
            imgUrl: logo2004,
          },
          {
            id: "judgment-day-2005",
            title: "Judgment Day",
            description: "2005 - 2008",
            imgUrl: logo2005_2008,
          },
          {
            id: "judgment-day-2009",
            title: "Judgment Day",
            description: "2009",
            imgUrl: logo2009,
          },
        ],
      },
    ],
  },
};
